import { render, staticRenderFns } from "./IncreaseChannel.vue?vue&type=template&id=7f04ac3f"
import script from "./IncreaseChannel.vue?vue&type=script&lang=js"
export * from "./IncreaseChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports